
<div class="container">
  <div class="row">
    <div class="col page-title-container">
      <h2 class="hidden-xs-down">Order</h2>
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a [routerLink]="['/projects']">Projects</a></li>
        <li class="breadcrumb-item" *ngIf="order?.projectId &amp;&amp; order?.projectName"><a [routerLink]="['/project']" [queryParams]="{id: order?.projectId}">{{ order?.projectName }}</a></li>
        <li class="breadcrumb-item"><a [routerLink]="['/sites']" [queryParams]="{projectId: order?.projectId}">Sites</a></li>
        <li class="breadcrumb-item" *ngIf="order?.siteId &amp;&amp; order?.siteName"><a [routerLink]="['/site']" [queryParams]="{id: order?.siteId}">{{ order?.siteName }}</a></li>
        <li class="breadcrumb-item" *ngIf="order?.siteId"><a [routerLink]="['/orders']" [queryParams]="{siteId: order?.siteId}">Orders</a></li>
        <li class="breadcrumb-item active" *ngIf="order?.name">{{ order?.name }}</li>
      </ol>
      <error [error]="error"></error>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div class="card-item" *ngIf="order">
        <div class="card-order-status float-right">
          <property-container class="font-30 red">
            <property-item [showIf]="order.pastSchedule"><span class="oi oi-clock" title="{{ order.statusMessage }}"></span></property-item>
          </property-container>
          <property-container class="font-30 green">
            <property-item [showIf]="!order.pastSchedule &amp;&amp; !order.rejected &amp;&amp; order.orderComplete"><span class="oi oi-check" title="{{ order.statusMessage }}"></span></property-item>
          </property-container>
        </div>
        <h4>{{ order.name }}<span class="badge ml-1" *ngIf="order.rejected" [ngClass]="{'badge-warning': true}">Rejected</span></h4>
        <div class="float-left">
          <property-container>
            <property-item><a [href]="'/#/workflow/' + order.workflowId">Set Up Order</a></property-item>
          </property-container>
          <property-container>
            <property-item><span>Assets: {{ order.plannedAssets }}</span></property-item>
            <property-item><span>Accessories: {{ order.plannedAccessories }}</span></property-item>
          </property-container>
          <property-container>
            <property-item [showIf]="order.hardwareOrderDate">Hardware Order Date: {{ order.hardwareOrderDate | date: 'yyyy-MM-dd' : 'UTC'}}</property-item>
          </property-container>
          <property-container class="red">
            <property-item [showIf]="order.pastSchedule"><span class="oi oi-clock"></span> {{ order.pastScheduleMessage }}</property-item>
          </property-container>
        </div>
        <div class="float-right">
          <property-container>
            <property-item [showIf]="!!order.hardwareOrderDetails?.length"><span>Order Numbers & Dates:</span>
              <ng-template ngFor let-element [ngForOf]="order.hardwareOrderDetails"><br><span>{{ element.orderNumber }} {{ element.orderDate | date: 'yyyy-MM-dd' : 'UTC' }}</span></ng-template>
            </property-item>
          </property-container>
        </div>
        <div class="clearfix"></div>
        <div class="float-right">
          <button class="btn btn-outline-danger float-right" *ngIf="!order.orderRequested &amp;&amp; !order.orderedItems" type="button" (click)="remove()"><span class="oi oi-trash"></span> Remove</button>
        </div>
        <div class="clearfix"></div>
      </div>
    </div>
  </div>
</div>